import React from 'react';
import './style.scss';
import { Icons } from '@hyperping/design';

const CardsBlock = ({ title, cards }) => {
  return (
    <div className="cards-block">
      <h2 className="text-align-center font-size-38px font-weight-500 mb-1em">{title}</h2>
      <div className="flex flex-direction-row gap-1em align-items-stretch justify-content-space-between">
        {cards.map((card, index) => (
          <a
            href={card.href}
            key={index}
            style={{
              flex: 1,
              minWidth: 0,
              textDecoration: 'none'
            }}
          >
            <div 
              className="border card" 
              style={{
                borderRadius: '16px',
                background: 'rgb(16, 23, 37)',
                padding: '1.5em',
                height: '100%',
                width: '100%'
              }}
            >
              <div className="flex flex-direction-row align-items-flex-start justify-content-space-between">
                <div className="font-size-18px font-weight-600 mb-05em ">{card.title}</div>
                <Icons name="arrowleft" style={{transform:'rotate(137deg)'}}/>
              </div>
              <div className="font-size-16px font-weight-300 line-height-143em text-light-grey">{card.content}</div>
            </div>
          </a>
        ))}
      </div>  
    </div>
  );
};

export default CardsBlock;